// Vendor
import { KeyValue } from '@angular/common';
import { Component, input } from '@angular/core';

// Interfaces
import { BackgroundJobProgressUpdate } from 'NotificationsApp/ts/interfaces/background-job.interface';

import { AccountsService } from 'AccountsApp/ts/services/accounts.service';

@Component({
    standalone: false,
    selector: 'ycn-background-jobs-progress-popover',
    templateUrl: './background-jobs-progress-popover.template.html',
})
export class BackgroundJobsProgressPopoverComponent {
    readonly jobsInProgress = input<{ [id: string]: BackgroundJobProgressUpdate }>({});

    isOpen: boolean = false;

    constructor(private accountsService: AccountsService) {}

    openModal(): void {
        this.isOpen = true;
    }

    closeModal(): void {
        this.isOpen = false;
    }

    dismissModal(): void {
        this.accountsService.putUserPreferences({ always_display_jobs_progress_popover: false }).subscribe();
        this.closeModal();
    }

    progressOrdering(_left: KeyValue<string, any>, _right: KeyValue<string, any>): number {
        // Maintain order that jobs were inserted into the jobsInProgress map
        return 0;
    }

    trackByJobId(_index: number, item: KeyValue<string, BackgroundJobProgressUpdate>): string {
        return item.key;
    }
}
